module.exports = __webpack_public_path__ + "static/media/02.9fd1a3d5.jpg";